import { WORDMARK_PATH } from './vector-shapes';
import './Wordmark.css';

export type WordmarkSize = 'h24' | 'h28' | 'h36' | 'h40' | 'h48' | 'h56' | 'h64';
export type WordmarkTone = 'brand' | 'inverse' | 'ink' | 'current';

export interface WordmarkProps {
  /** Altura CSS; a largura sai da proporção do raster. */
  size: WordmarkSize;
  /** De onde vem a cor: a marca roxa, branco (sobre imagem ou roxo), a tinta, ou o texto em volta. */
  tone?: WordmarkTone;
  className?: string;
  label?: string;
}

/** O wordmark ∫hibΔ em SVG inline: nítido e sem depender de uma máscara externa. */
export function Wordmark({ size, tone = 'brand', className, label = '∫hibΔ' }: WordmarkProps) {
  const classes = ['wordmark', `wordmark--${size}`, `wordmark--${tone}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <svg role="img" aria-label={label} className={classes} viewBox="0 0 1200 687">
      <path d={WORDMARK_PATH} fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}
